import React, { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/ProtectedRoute";
import FeedbackWidget from "./components/FeedbackWidget";
import { initGA, trackPageView } from "./utils/analytics";

// Pages
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import Dashboard from "./pages/Dashboard";
import Study from "./pages/Study";
import Results from "./pages/Results";
import Subscription from "./pages/Subscription";
import AuthCallback from "./pages/AuthCallback";
import AdminFeedback from "./pages/AdminFeedback";

// GA4 Page View Tracker
function PageViewTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  
  return null;
}

function App() {
  // Initialize GA4 on app load
  useEffect(() => {
    initGA();
  }, []);

  return (
    <AuthProvider>
      <BrowserRouter>
        <PageViewTracker />
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<Signup />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          
          {/* Protected Routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/study/:sessionId" element={
            <ProtectedRoute>
              <Study />
            </ProtectedRoute>
          } />
          <Route path="/results/:contentId" element={
            <ProtectedRoute>
              <Results />
            </ProtectedRoute>
          } />
          <Route path="/subscription" element={
            <ProtectedRoute>
              <Subscription />
            </ProtectedRoute>
          } />
          <Route path="/subscription/success" element={
            <ProtectedRoute>
              <Subscription />
            </ProtectedRoute>
          } />
          <Route path="/admin/feedback" element={
            <ProtectedRoute>
              <AdminFeedback />
            </ProtectedRoute>
          } />
        </Routes>
        <Toaster position="top-center" richColors />
        <FeedbackWidget />
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
